const FooterDisclaimer = () => (
  <div
    className="container pt-4 pt-lg-5 new-disclaimer"
    style={{ maxWidth: "1120px" }}
  >
    <div className="row justify-content-center">
      <div className="col-11 col-lg-12">
        <strong>1.</strong> As fórmulas Puríssima são manipuladas sob
        prescrição e personalizadas individualmente a partir da anamnese de
        cada pessoa, com revisão por equipe de nutricionistas e
        farmacêuticos. As quantidades de cada ingrediente são definidas caso
        a caso e podem variar conforme idade, sexo, peso, rotina, condições
        de saúde e objetivos. <strong>2.</strong> Este conteúdo tem caráter
        informativo e não substitui a orientação, o diagnóstico ou o
        tratamento de um profissional de saúde. Suplementos alimentares não
        são medicamentos e não se destinam a prevenir, tratar ou curar
        doenças. Em caso de doença preexistente, uso de medicamentos,
        gravidez ou amamentação, consulte seu médico antes de iniciar
        qualquer suplementação. <strong>3.</strong> Resultados variam de
        pessoa para pessoa e dependem de fatores individuais, incluindo
        alimentação, sono, atividade física e constância de uso. As
        afirmações sobre os ingredientes referem-se a funções nutricionais e
        fisiológicas gerais reconhecidas pela literatura científica, e não a
        promessas de resultado. <strong>4.</strong> Gestantes, lactantes,
        menores de idade e pessoas com condições clínicas específicas devem
        buscar avaliação profissional individualizada. A Puríssima detecta
        na anamnese situações que exigem acompanhamento médico e orienta
        cada caso adequadamente.
      </div>
      {/* <strong>5.</strong> Programa de indicação:
        o desconto de 10% é aplicado à fórmula do indicante a cada nova
        adesão efetivada a partir do seu convite, conforme regulamento.
        Consulte os termos completos. */}
      <div
        className="col-11 col-lg-12 mt-3 mt-lg-4"
        style={{ fontWeight: "700" }}
      >
        © 2026 Puríssima Farmácia de Manipulação S.A - CNPJ
        58.771.439/0001-06 | Farmacêutica Responsável: Paula Souza de Sales
        - CRF/MG 51.370 | AFE: 5.21558-1 / Licença Sanitária: 1531/2025 /
        Certidão de Regularidade: 47.692 | Preços e condições exclusivos
        para o site www.purissima.com, podendo sofrer alterações sem prévia
        notificação. | Esta farmácia segue as determinações da ANVISA.
      </div>
    </div>
  </div>
);

export default FooterDisclaimer;
